import { render } from "./LandingPageSummarySection.vue?vue&type=template&id=95166cf4&scoped=true"
import script from "./LandingPageSummarySection.vue?vue&type=script&lang=js"
export * from "./LandingPageSummarySection.vue?vue&type=script&lang=js"

import "./LandingPageSummarySection.vue?vue&type=style&index=0&id=95166cf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95166cf4"]])

export default __exports__